import React, { useState, useContext } from "react";
import { Select, Popover } from "antd";
import SmallModal from "../../components/SmallModal/SmallModal";
import { truncate } from "../../library/text";
import { AppContext } from "../../context";
import { RiCalendarEventFill } from "react-icons/ri";
import { GoWatch } from "react-icons/go";
import { ImLocation2 } from "react-icons/im";

function EventCardContent({ product, context }) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const info = useContext(AppContext);

  const popoverContent = (
    <div>
      <p>{product.request}</p>
    </div>
  );

  const productQuantityOptions = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ];

  const handleQuantitySelection = (value) => {
    // setProductConfig({
    //   people: value,
    //   gen_price: product.gen_price * value,
    // });
  };

  const selectComponent = () => {
    switch (context) {
      // card content for grid/list of events
      case undefined:
        return (
          <>
            <div className="card-body">
              <div className="short-description">
                {product.gen_description
                  ? truncate(product.gen_description["pt-pt"], 100, true)
                  : ""}
              </div>
              {product.eve_by && (
                <div className="ahp-card-date">
                  <strong>Por: </strong>
                  {product.eve_by}
                </div>
              )}
              {product.eve_venue && (
                <div className="ahp-card-date">
                  <ImLocation2 />
                  {product.eve_venue}
                </div>
              )}
              {product.eve_date && (
                <div className="ahp-card-date">
                  <RiCalendarEventFill /> {product.eve_date}
                </div>
              )}
              {product.eve_time && (
                <div className="ahp-card-date">
                  <GoWatch /> {product.eve_time}
                </div>
              )}
            </div>
          </>
        );
      case "reservation-info":
        return (
          <>
            {" "}
            <div
              style={{
                marginTop: 20,
                padding: 5,
                backgroundColor: "grey",
                color: "white",
                textAlign: "center",
              }}
            >
              <RiCalendarEventFill /> {product.eve_date} <GoWatch />
              {"     "}
              {product.eve_time}
            </div>
            <div className="ahp-card-date"></div>
            <div>Selecione o número de bilhetes</div>
            <Select
              options={productQuantityOptions}
              value={info.event?.tickets}
              // defaultValue={1}
              onSelect={(value) =>
                info.setEvent({ ...info.event, tickets: value })
              }
              bordered={false}
            />
            {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginTop: 16,
                  marginBottom: 16,
                }}
              >
                <button
                  type="button"
                  className="ahp-button"
                  onClick={() => setIsAddedToCartVisible(false)}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="ahp-button"
                  onClick={handleAddToCart}
                >
                  Reservar
                </button>
              </div> */}
          </>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <div>
            <div className="ahp-reservation-content">
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Nº de bilhetes</div>
                <div className="ahp-reservation-value">
                  {product.gen_quantity}
                </div>
              </div>
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Preço</div>
                <div className="ahp-reservation-value">
                  {product.gen_price} €
                </div>
              </div>
              {context !== "reservation-info" && product.request && (
                <div className="ahp-reservation-notes">
                  <Popover
                    content={popoverContent}
                    title="Notas"
                    trigger="click"
                  >
                    <a role="button" tabindex="0">
                      Notas
                    </a>
                  </Popover>
                </div>
              )}
            </div>
          </div>
        );
        break;
      default:
        return <div></div>;
        break;
    }
  };

  return (
    <>
      {product.gen_price !== null &&
        product.gen_price !== 0 &&
        context != "ticket" &&
        context != "reservation-info" &&
        context != "payment" &&
        !(
          product.status == "not-available" || product.status == "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">{product.gen_price} €</div>
          </div>
        )}
      {selectComponent()}

      <SmallModal
        text="Preço total."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
      />
    </>
  );
}

export default EventCardContent;
